import React from "react";

/**
 * Outline icons for the survey kinds, in the same spirit as `ReactIcons`: 24x24 viewBox and
 * `currentColor` only, so `Card.module.css` keeps driving the color (including the selected state).
 */

type SurveyIconProps = React.SVGProps<SVGSVGElement>;

const SurveyIcon = ({ children, style, ...props }: SurveyIconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: "2.5em", height: "2.5em", ...style }}
    {...props}
  >
    {children}
  </svg>
);

/** A checkmark next to a cross. */
const YesNo = (props: SurveyIconProps) => (
  <SurveyIcon {...props}>
    <path d="M2 12.5 5.5 16l5-8.5" />
    <path d="M15 8.5 21.5 15.5M21.5 8.5 15 15.5" />
  </SurveyIcon>
);

/** A toggle switch: the binary answer. */
const TrueFalse = (props: SurveyIconProps) => (
  <SurveyIcon {...props}>
    <rect x="2" y="7" width="20" height="10" rx="5" />
    <circle cx="17" cy="12" r="2.75" fill="currentColor" stroke="none" />
  </SurveyIcon>
);

/** A balance scale: weighing one side against the other. */
const ForAgainstNoOpinion = (props: SurveyIconProps) => (
  <SurveyIcon {...props}>
    <path d="M12 4.5v15.5M8 20h8" />
    <path d="M4 7.5h16" />
    <path d="M4 8.5 7 13.5H1z" />
    <path d="M20 8.5 23 13.5h-6z" />
  </SurveyIcon>
);

/** A list of options, one of them selected. */
const MultipleChoice = (props: SurveyIconProps) => (
  <SurveyIcon {...props}>
    <circle cx="4.5" cy="6" r="2" />
    <circle cx="4.5" cy="12" r="2" fill="currentColor" />
    <circle cx="4.5" cy="18" r="2" />
    <path d="M9.5 6h11M9.5 12h11M9.5 18h11" />
  </SurveyIcon>
);

/** A rating star. */
const Stars = (props: SurveyIconProps) => (
  <SurveyIcon {...props}>
    <path d="M12 2.8l2.9 5.88 6.5.95-4.7 4.58 1.11 6.49L12 17.64l-5.81 3.05 1.11-6.49-4.7-4.58 6.5-.95z" />
  </SurveyIcon>
);

/** A pencil: the survey is written from scratch. */
const Custom = (props: SurveyIconProps) => (
  <SurveyIcon {...props}>
    <path d="M3 21l.95-3.8a2 2 0 0 1 .53-.94L15.9 4.98a2.5 2.5 0 0 1 3.54 3.54L7.9 20.06a2 2 0 0 1-.94.53z" />
    <path d="M14.4 6.5l3.54 3.54" />
  </SurveyIcon>
);

export const SurveyIcons = {
  YesNo,
  TrueFalse,
  ForAgainstNoOpinion,
  MultipleChoice,
  Stars,
  Custom,
};
